import "./registerServiceWorker";
import { installChunkLoadErrorHandler } from "@/lib/chunkLoad";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { setPWAPrompt } from "@/lib/pwa";
import { detectWebpSupport } from "@/lib/webpSupport";
import { applyPolyfills } from "@/modules/polyfills";
import createApp from "@/main";

installChunkLoadErrorHandler();
setPWAPrompt();

// thumbnail URLs are built at render time, so the format must be known before the first mount
const enableWebpThumbnails = detectWebpSupport().then(supported => {
  if (supported) MediaFilesController.setThumbnailFormat("webp");
});

Promise.all([applyPolyfills(), enableWebpThumbnails])
  .then(() => createApp())
  .then(({ app }) => app.$mount("#app"));
